/**
 * PaceStrip — Phase 16.2 compact variant.
 *
 * Height: 40px target (per Phase 16.2 spec). Status pill 11px, metrics 12px,
 * horizontal padding 1rem. Pace = where the agency stands today vs the
 * monthly trips target (Ahead / On track / Behind) driven by `pace`
 * from /api/dashboard/plus.
 */
import React from 'react';
import { TrendingUp, Plane } from 'lucide-react';

const PaceStrip = ({ pace = {} }) => {
  const tripsToday = Number(pace.tripsToday || 0);
  const tripsThisMonth = Number(pace.tripsThisMonth || 0);
  const monthTarget = Number(pace.tripsMonthTarget || 0);
  const departures48h = Number(pace.departures48h || 0);

  const _status = () => {
    if (monthTarget <= 0) return { label: 'Pace', tone: 'slate' };
    const expected = (monthTarget / 30) * (new Date().getDate());
    if (tripsThisMonth >= expected * 1.1) return { label: 'Ahead',    tone: 'emerald' };
    if (tripsThisMonth >= expected * 0.9) return { label: 'On track', tone: 'emerald' };
    return { label: 'Behind', tone: 'rose' };
  };
  const status = _status();
  const tonePill = status.tone === 'emerald'
    ? 'bg-emerald-100 text-emerald-800 border-emerald-200'
    : status.tone === 'rose'
      ? 'bg-rose-100 text-rose-800 border-rose-200'
      : 'bg-slate-100 text-slate-700 border-slate-200';

  return (
    <div
      data-testid="pace-strip"
      className="flex items-center gap-3 px-4 bg-white border border-slate-200 rounded-[10px] shadow-sm"
      style={{ height: 40 }}
    >
      <span
        data-testid="pace-strip-status"
        className={`inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-semibold rounded-full border ${tonePill}`}
      >
        <TrendingUp className="h-3 w-3" /> {status.label}
      </span>
      <span data-testid="pace-trips-today" className="text-[12px] text-slate-700">
        <span className="font-semibold">{tripsToday}</span> trips today
      </span>
      <span className="text-slate-300">·</span>
      <span data-testid="pace-trips-month" className="text-[12px] text-slate-700">
        <span className="font-semibold">{tripsThisMonth}</span>
        {monthTarget > 0 && <span className="text-slate-400"> / {monthTarget}</span>}
        <span className="text-slate-500"> this month</span>
      </span>
      {departures48h > 0 && (
        <>
          <span className="text-slate-300">·</span>
          <span data-testid="pace-departures-48h" className="text-[12px] text-rose-700 inline-flex items-center gap-1">
            <Plane className="h-3 w-3" />
            <span className="font-semibold">{departures48h}</span> in 48h
          </span>
        </>
      )}
    </div>
  );
};

export default PaceStrip;
